export const ROLE_LABELS = {
  admin: "Owner / Admin",           // L1
  dept_head: "Executive Head",      // L1
  sales: "Sales Executive",         // L2
  procurement: "Purchase Head",     // L2
  procurement_staff: "Purchase Staff",  // L3
  tender: "Tender Head",            // L2
  tender_assistant: "Tender Assistant",  // L3
  production: "Production Supervisor",  // L2
  dispatch: "Dispatch Head",        // L2
  accounts: "Accounts Head",        // L2
  rnd: "R&D Head",                  // L2
  store: "Store / Factory Head",    // L2
  engineer: "Field Engineer",       // L3
  staff: "Staff",                   // L3
  marketing: "Digital Marketing",   // L3
  ecommerce: "E-commerce Sales",    // L2
  designer: "Catalog Designer",     // L3
  demo_install: "Demo & Installation Executive",  // L2
  mis_executive: "MIS Executive",  // L2
};

// Hierarchy tiers — mirrored from backend/modules_schema.py:ROLE_TIER
export const ROLE_TIER = {
  admin: 1, dept_head: 1,
  sales: 2, procurement: 2, tender: 2, production: 2,
  dispatch: 2, accounts: 2, rnd: 2, store: 2,
  ecommerce: 2, demo_install: 2, mis_executive: 2,
  engineer: 3, staff: 3, procurement_staff: 3,
  tender_assistant: 3, marketing: 3, designer: 3,
};

export const TIER_LABEL = {
  1: "Level 1 · Executive",
  2: "Level 2 · Department Head",
  3: "Level 3 · Team",
};

export const TIER_STYLE = {
  1: "bg-blue-50 text-blue-700 border-blue-200",
  2: "bg-emerald-50 text-emerald-700 border-emerald-200",
  3: "bg-slate-100 text-slate-700 border-slate-200",
};

export const ROLES = Object.keys(ROLE_LABELS);

export const STATUS_BADGE = (status) => {
  const s = (status || "").toLowerCase();
  if (["completed", "approved", "won", "active", "paid", "delivered", "selected", "passed", "submitted", "closed"].some(k => s.includes(k))) {
    return "bg-emerald-50 text-emerald-700 border-emerald-200";
  }
  if (["delayed", "rejected", "lost", "failed", "expired", "inactive", "cancelled"].some(k => s.includes(k))) {
    return "bg-red-50 text-red-700 border-red-200";
  }
  if (["pending", "on hold", "awaiting", "reviewing", "negotiation"].some(k => s.includes(k))) {
    return "bg-amber-50 text-amber-700 border-amber-200";
  }
  if (["in progress", "in transit", "scheduled", "demo planned", "will bid"].some(k => s.includes(k))) {
    return "bg-blue-50 text-blue-700 border-blue-200";
  }
  if (["new", "not started", "received"].some(k => s.includes(k))) {
    return "bg-slate-100 text-slate-700 border-slate-200";
  }
  return "bg-slate-100 text-slate-700 border-slate-200";
};

// Purchase Order lifecycle colour coding (module-specific, per owner's spec):
// In Progress → RED, Dispatched → YELLOW, Delivered → BLUE, Installed → GREEN.
export const PO_STATUS_BADGE = (status) => {
  const s = (status || "").toLowerCase();
  if (s === "in progress" || s === "delayed" || s === "cancelled") return "bg-red-50 text-red-700 border-red-200";
  if (s === "dispatched") return "bg-amber-50 text-amber-700 border-amber-200";
  if (s === "delivered") return "bg-blue-50 text-blue-700 border-blue-200";
  if (s === "installed" || s === "closed") return "bg-emerald-50 text-emerald-700 border-emerald-200";
  return "bg-slate-100 text-slate-700 border-slate-200";
};

// Whole-row colour coding for Purchase Master entries — the entire row is
// filled with the status colour (no left band) so status reads at a glance.
export const PO_ROW_TINT = (status) => {
  const s = (status || "").toLowerCase();
  if (s === "in progress" || s === "delayed" || s === "cancelled") return "bg-red-100 hover:bg-red-200/70";
  if (s === "dispatched") return "bg-amber-100 hover:bg-amber-200/70";
  if (s === "delivered") return "bg-blue-100 hover:bg-blue-200/70";
  if (s === "installed" || s === "closed") return "bg-emerald-100 hover:bg-emerald-200/70";
  return "hover:bg-slate-50/60";
};

export const formatCurrency = (n) => {
  if (n == null || n === "") return "—";
  const num = Number(n);
  if (isNaN(num)) return n;
  return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(num);
};

export const formatNumber = (n) => {
  if (n == null || n === "") return "—";
  const num = Number(n);
  if (isNaN(num)) return n;
  return new Intl.NumberFormat("en-IN").format(num);
};
